import * as React from 'react'

import { Button } from 'reactstrap'

import TerminationFormData from '../TerminationFormData.interface'
import TerminationFormDataUpdate from '../TerminationFormDataUpdate.type'

export interface TerminationCheckVoluntaryProps {
  terminationForm: TerminationFormData
  statusCallback: TerminationFormDataUpdate
}

class TerminationCheckVoluntary extends React.PureComponent<TerminationCheckVoluntaryProps> {
  constructor(props) {
    super(props)
    this.updateVoluntaryStatus = this.updateVoluntaryStatus.bind(this)
  }

  updateVoluntaryStatus(voluntary: boolean) {
    const { terminationForm } = this.props

    terminationForm.voluntary = voluntary
    this.props.statusCallback('TERMINATION_DATE', terminationForm)
  }

  render() {
    return (
      <div className="p4">
        <h5 className="text-justify mb-4">Is this termination voluntary or involuntary?</h5>
        <Button color="primary" className="btn-block" onClick={e => this.updateVoluntaryStatus(true)}>
          Voluntary
        </Button>
        <Button color="light" className="btn-block" onClick={e => this.updateVoluntaryStatus(false)}>
          Involuntary
        </Button>
      </div>
    )
  }

}

export default TerminationCheckVoluntary


// WEBPACK FOOTER //
// ./src/routes/terminations/termination-flow/components/TerminationCheckVoluntary.component.tsx